import { useState } from "react";
import { act, post } from "../lib/api";
import { Sheet } from "./bits";
import { hmin } from "../lib/time";

export function UnplannedSheet({ clients, onClose, onDone }) {
  const [f, setF] = useState({ client: "", title: "", h: 0, m: 0, startTimer: true });
  const [err, setErr] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  async function save() {
    const r = await post("/timer/unplanned", { client: f.client || null, title: f.title, pocs: [], startTimer: f.startTimer,
      hours: f.h * 60 + f.m ? (f.h * 60 + f.m) / 60 : null });
    if (!r.ok) return setErr(r.error.message);
    await act(Promise.resolve(r));
    onDone();
  }
  return (
    <Sheet title="Log unplanned" onClose={onClose} testid="unplanned-sheet">
      <label className="fld-lbl">Client</label>
      <select className="fld" value={f.client} onChange={set("client")} data-testid="unplanned-client">
        <option value="">Pick a client</option>
        {clients.map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}
      </select>
      <label className="fld-lbl">What are you doing?</label>
      <input className="fld" value={f.title} onChange={set("title")} placeholder="Resize 3 posts for LinkedIn" data-testid="unplanned-title" />
      <label className="fld-lbl">Estimate (optional)</label>
      <div className="est-custom">
        <select className="fld sm" aria-label="Hours" value={f.h} onChange={(e) => setF({ ...f, h: Number(e.target.value) })} data-testid="unplanned-hours">
          {Array.from({ length: 8 }, (_, i) => <option key={i} value={i}>{i}h</option>)}</select>
        <select className="fld sm" aria-label="Minutes" value={f.m} onChange={(e) => setF({ ...f, m: Number(e.target.value) })} data-testid="unplanned-minutes">
          {Array.from({ length: 12 }, (_, i) => i * 5).map((x) => <option key={x} value={x}>{String(x).padStart(2, "0")}m</option>)}</select>
        <span className="hint0">{f.h * 60 + f.m ? hmin(f.h * 60 + f.m) : "No estimate"}</span>
      </div>
      <label className="check"><input type="checkbox" checked={f.startTimer} onChange={set("startTimer")} data-testid="unplanned-start" /> Start the timer now</label>
      {err && <p className="err" data-testid="unplanned-error">{err}</p>}
      <button className="btn-primary" onClick={save} data-testid="unplanned-save">Log it</button>
    </Sheet>
  );
}

export function AddTimeSheet({ task, onClose, onDone }) {
  const [h, setH] = useState(0.5);
  const [note, setNote] = useState("");
  const [err, setErr] = useState(null);
  async function save() {
    const r = await post(`/tasks/${task.id}/add-time`, { hours: h, note });
    if (!r.ok) return setErr(r.error.message);
    await act(Promise.resolve(r));
    onDone();
  }
  return (
    <Sheet title="Add time" onClose={onClose} testid="addtime-sheet">
      <div className="chips">
        {[[0.5, "0h 30m"], [1, "1h 00m"], [2, "2h 00m"], [3.75, "Half day"]].map(([v, l]) => (
          <button key={v} className={`chip-btn ${h === v ? "on" : ""}`} onClick={() => setH(v)} data-testid={`addtime-${l}`}>{l}</button>
        ))}
      </div>
      <label className="fld-lbl">What changed?</label>
      <input className="fld" value={note} onChange={(e) => setNote(e.target.value)} maxLength={140} data-testid="addtime-note" />
      {err && <p className="err" data-testid="addtime-error">{err}</p>}
      <button className="btn-primary" onClick={save} data-testid="addtime-save">Add time</button>
    </Sheet>
  );
}
